import { CycleStatistics } from '@/service/models/response/computation/data-responses/cycle-data/cycle-statistics';
import { ParametersVM } from '@/service/view-models/cycle-data/parameters-vm';
import { defineStore } from 'pinia';

export const useReportStore = defineStore({
    id: 'reportStore',
    
    state()
    {
        return {
            nextControlDate: null as Date|null,
            validationDate: null as Date|null,

            pkParameters: new ParametersVM([], [], []),
            steadyStateStats: null as CycleStatistics|null,

            expectedness: "",
            suitability: "",
            prediction: "",
            remonitoring: "",
            warning: "",
        };
    },

    getters: {
    },

    actions: {
    },
});
